<div class="modal-body">

  <div class="title_">{{ title }}</div>
  <div class="modal-text-wrapper">
    <p>{{information}}</p>
  </div>
  <button type="button"
          class="button button-active"
          (click)="activeModal.close('')">
    {{positiveButton}}
  </button>
  <button type="button"
          class="button button-default"
          (click)="activeModal.dismiss('')">
    {{negativeButton}}
  </button>
</div>
